import script from "./KurvaSChart.vue?vue&type=script&setup=true&lang=js"
export * from "./KurvaSChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__